var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 54.5002C25.7998 54.5002 41.5996 46.6001 41.5996 34.7501V20.925L25.7998 15L10 20.925V34.7501C10 46.6001 25.7998 54.5002 25.7998 54.5002Z",
    fill: "url(#paint0_linear_250_7224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1025 23.7583H28.4362C26.9634 23.7583 25.7695 24.9522 25.7695 26.425V35.7583C25.7695 37.2311 26.9634 38.425 28.4362 38.425H47.1025C48.5752 38.425 49.7691 37.2311 49.7691 35.7583V26.425C49.7691 24.9522 48.5752 23.7583 47.1025 23.7583Z",
    fill: "url(#paint1_linear_250_7224)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1006 23.7588V18.4255C31.1006 16.6573 31.803 14.9617 33.0532 13.7114C34.3034 12.4612 35.9991 11.7588 37.7671 11.7588C39.5352 11.7588 41.2309 12.4612 42.4811 13.7114C43.7313 14.9617 44.4337 16.6573 44.4337 18.4255V23.7588",
    stroke: "#9AB0FF",
    strokeWidth: 2.66664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_7224",
    x1: 14.3203,
    y1: 15,
    x2: 25.8002,
    y2: 54.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6530A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_7224",
    x1: 27.1028,
    y1: 23.7583,
    x2: 48.4361,
    y2: 41.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45FFE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyLock);
export default __webpack_public_path__ + "static/media/PrivacyLock.04b7ac40e838844017b61bbdc7ddfa8f.svg";
export { ForwardRef as ReactComponent };